module.exports = __webpack_public_path__ + "img/shg22_samurai02_shop.f4d1c51f.png";